
import styled from 'styled-components'
import { BP } from 'resources/constants'

export const Wrapper = styled.div<any>`
  position: relative;
  z-index: 3;

  a.cart-link {
    padding: 0 5px 0 10px;
    text-decoration: none;
    height: auto;
    display: flex;
    align-items: center;

    @media (min-width: ${BP.sm.min}) {
      padding: 0;
    }

    span {
      text-transform: uppercase;
      font-weight: 600;
      font-size: ${props => props.isLivBrite ? '18px' : '16px'};
      padding-left: 5px;
    }

    svg {
      cursor: pointer;
      width: auto;
      position: relative;
      z-index: 4;
      height: 29px;

      > g {
        fill: ${props => props.theme.palette.primary.alpha};
      }
    }
  }

  @media (min-width: ${BP.md.min}) {
    &:hover .dropdown {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
`

export const CartCount = styled.span`
  padding: 0;
  font-size: 22px;
  text-decoration: none;
  color: ${props => props.theme.palette.primary.alphaDark};
`

export const DropDown = styled.div<any>`
  height: auto;
  background: #fff;
  border: 1px solid ${props => props.theme.palette.general.borderColor};
  width: 300px;
  position: absolute;
  top: 42px;
  right: -3px;
  padding: 25px 25px 20px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  transform: translateY(-10px);
  opacity: 0;
  visibility: hidden;
  transition: transform 200ms ease-in-out, opacity 150ms ease-in-out, visibility 150ms ease-in-out;

  &::after,
  &::before {
    content: '';
    display: block;
    position: absolute;
    right: 15px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 15px 15px 7px 15px;
  }

  &::after {
    top: -23px;
    border-color: transparent transparent ${props => props.theme.palette.general.borderColor} transparent;
  }

  &::before {
    top: -22px;
    border-color: transparent transparent #fff transparent;
    z-index: 9;
  }

  .items-in-cart {
    font-size: ${props => props.isLivBrite ? '18px' : '15px'};
    margin: 0 0 10px;
    padding: 0;
    font-weight: 600;
  }
`

export const Actions = styled.div<any>`
  border-top: 1px solid ${props => props.theme.palette.general.borderColor};
  margin: 15px 0 0;
  padding: 15px 0 0;
  display: flex;
  align-items: center;

  a {
    text-transform: none;
    font-size: ${props => props.isLivBrite ? '16px' : '14px'};
    flex: 1;
    padding: 0 5px;
    white-space: nowrap;
    ${props => props.theme.css.link};
  }

  button {
    ${props => props.theme.css.buttonPrimary};
    min-width: 160px !important;
  }
`
